module.exports = __webpack_public_path__ + "static/media/video_verfication_audio.a7dbd16a.mp3";